import { render, staticRenderFns } from "./tixian02.vue?vue&type=template&id=0f9bc1e8&scoped=true"
import script from "./tixian02.vue?vue&type=script&lang=js"
export * from "./tixian02.vue?vue&type=script&lang=js"
import style0 from "./tixian02.vue?vue&type=style&index=0&id=0f9bc1e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9bc1e8",
  null
  
)

export default component.exports